import {AnalyticsMethods} from './types'

let globalAnalyticsQueue: AnalyticsMethods | null = null

/**
 * Can be used by Class Components that cannot use the `useAnalytics` hook.
 * `useAnalytics` should be preferred over this method where possible.
 */
export const getAnalyticsQueue = (): AnalyticsMethods | null => {
  if (!globalAnalyticsQueue) {
    console.warn('AnalyticsQueue referenced before initialization')
  }
  return globalAnalyticsQueue
}

/**
 * Should only be called by AnalyticsQueueContextProvider.
 * @invitae/analytics-queue `useAnalyticsQueue` doesn't actually return the underlying AnalyticsQueue object,
 * so we make do with relying on the methods it does make available.
 */
export const setGlobalAnalyticsQueue = (queue: AnalyticsMethods): void => {
  globalAnalyticsQueue = queue
}
